import FadeIn from "../../../components/animation/fadeIn";
import Category from "../../../components/category/category";

import { lifecycle } from "../../../constants/lifecycle";

export default function LifeCycle() {
    return (
        <section id="Lifecycle">
            <Category>LifeCycle</Category>
            {lifecycle.map((val, i) => (
                <p key={ i } className="article-information">{val}</p>
            ))}
            <FadeIn animateFrom={{ x: '300', opacity: '0' }} animateTo={{ x: '0', opacity: '1' }} onView={ true } rootMargin='10px' threshold={ 0.1 } delay={ 100 } transitionDuration={ 800 }>
                <blockquote>“Death is the start of a beginning, life is the start of the end, and the cycle continues forever." &mdash; Some nerd on the internet</blockquote>
            </FadeIn>
        </section>
    );
};